import {stateLabel, stateOptions} from "@/scripts/util/country-fields"
import {findProductSku, findTag} from "@/scripts/util/getProductData"
import Cookies from "js-cookie"

const _marketing_store = JSON.parse(Cookies.get(`_marketing_store`) ?? `{}`)

const utm_hidden_fields = [
    {
        name: `affiliate_id`,
        value: _marketing_store.affiliate ?? ``
    },
    {
        name: `affiliate_name`,
        value: _marketing_store.contact ?? ``
    },
    {
        name: `dealer_rep_name`,
        value:  _marketing_store.salesperson ?? ``
    },
    {
        name: `dealer_rep_id`,
        value: _marketing_store.dealer ?? ``
    },
    {
        name: `ga_user`,
        value: ``
    },
    {
        name: `ga_session`,
        value: ``
    },
    {
        name: `utm_source`,
        value: _marketing_store.utm_source ?? ``
    },
    {
        name: `utm_medium`,
        value: _marketing_store.utm_medium ?? ``
    },
    {
        name: `utm_campaign`,
        value: _marketing_store.utm_campaign ?? ``
    },
    {
        name: `utm_content`,
        value: _marketing_store.utm_content ?? ``
    },
    {
        name: `utm_term`,
        value: _marketing_store.utm_term ?? ``
    },
    {
        name: `country_code`,
        value: window.Shopify.country
    },
    {
        name: `currency`,
        value: `${window.Shopify.country}D`
    },
    {
        name: `page_source`,
        value: `https://${window.location.host}${window.location.pathname}`
    },
    {
        name: `lead_source`,
        value: `Web (Marketing)`
    },
    {
        name: `language`,
        value: window.Shopify.locale
    },
]

const default_hidden_product_fields = (product, productMeta) => {
    return [
        {
            name: `asset_category`,
            value: findTag(product.tags, `cat:`, true)
        },
        {
            name: `asset_sub_category`,
            value: findTag(product.tags, `subcat:`, true)
        },
        {
            name: `asset_number`,
            value: findProductSku(product.variants)
        },
        {
            name: `asset_name`,
            value: product.title
        },
        {
            name: `asset_link`,
            value: window.location.toString()
        },
        {
            name: `total_weekly_rental`,
            value: productMeta?.weeklyrental ?? product.price * 0.055 * 12 / 52
        },
        {
            name: `rentalprice`,
            value: productMeta?.rentalprice ?? product.price
        },
        {
            name: `lead_category`,
            value: `${product.tags.includes(`shopcondition:New`) ? `New` : `Used`} Equipment`,
        },
        {
            name: `lead_sub_category`,
            value: `Product Enquiry`,
        },
        ...utm_hidden_fields
    ]
}

const default_enquiry_fields = [
    [
        {
            name: `first_name`,
            label: `First Name`,
            required: true
        },
        {
            name: `last_name`,
            label: `Last Name`,
            required: true
        },
    ],
    {
        name: `state`,
        label: stateLabel(),
        type: `select`,
        options: stateOptions(),
        required: true
    },
    {
        name: `email`,
        label: `Email`,
        type: `email`,
        required: true,
    },
    {
        name: `phone`,
        label: `Mobile Phone`,
        type: `tel`,
        required: true,
    },
    {
        name: `note`,
        label: `What would you like to know about this equipment?`,
        type: `textarea`,
        required: false,
    }
]

export {default_enquiry_fields, default_hidden_product_fields, utm_hidden_fields}
